import { useProductType, getProductType } from '../services/ProductTypesManager'
import { useEffect, useCallback } from 'react'
import {
  getProductTypeForCoupon,
  isValidForProductType,
} from '../stores/promoCodeStore/promoCode.utils'
import { promoCodeManager } from '../services/PromoCodeManager'
import { useLocation, useSearchParams } from 'react-router'
import { useCartStoreOrNull } from '../stores/cartStore/CartStoreProvider'
import { useMobxSelector } from '../utils/mobx/useMobxSelector'

export const useSetInitialCoupon = () => {
  const { productType: currentProductType } = useProductType()
  const { pathname } = useLocation()
  const [searchParams] = useSearchParams()
  const cartStore = useCartStoreOrNull()
  const hasTilesInBag = useMobxSelector(
    () => cartStore?.tilesItem !== undefined,
    [cartStore]
  )

  const getEffectiveProductType = useCallback(() => {
    // If we're on the /getStarted route, check if there's a redirectTo parameter
    if (pathname.startsWith('/getstarted')) {
      const redirectTo = searchParams.get('redirectTo')

      if (redirectTo) {
        // Extract the pathname by removing query parameters
        const destinationProductType = getProductType(redirectTo)
        if (destinationProductType) {
          return destinationProductType
        }
      }
    }

    // Default to the current product type
    return currentProductType
  }, [currentProductType, pathname, searchParams])

  useEffect(() => {
    const effectiveProductType = getEffectiveProductType()

    const currentCoupon = promoCodeManager.getDiscountCoupon()

    if (!currentCoupon) return

    const isCouponValidOnPage = (coupon: object) =>
      isValidForProductType(
        coupon,
        getProductTypeForCoupon(coupon, {
          pageProductType: effectiveProductType,
          hasTilesInBag,
        })
      )

    // Update promo code if it is not valid for the current product
    // Use last valid promo code if available
    if (!isCouponValidOnPage(currentCoupon)) {
      const validPromo = promoCodeManager
        .getAllDiscountCoupons()
        .slice()
        .reverse()
        .find(isCouponValidOnPage)
      promoCodeManager.setDiscountCoupon(validPromo || null)
    }
  }, [getEffectiveProductType, hasTilesInBag])
}
